import Text from "../../../../../../../shared/components/Text";
import { DataRow } from "./DataRow";
import { formatMoney } from "nemuru-components";
import { formatDateReadable, Locale } from "@nemuru-eng/js-api-client";
import React from "react";
import { Box, Button } from "@material-ui/core";

export const QuotaSummary = ({
  paymentPlan,
  paymentPlanLine,
  navigateToPaymentPlan,
}) => {
  return (
    <>
      <Box width={"100%"}>
        <DataRow
          label={"QUOTA_NUMBER"}
          value={
            <>
              {`${paymentPlanLine.quota_number + 1} `}
              <Text tId={"OF"} />
              {` ${paymentPlan.lines.length}`}
            </>
          }
        />
        <DataRow
          label={"QUOTA_AMOUNT"}
          value={formatMoney(paymentPlanLine.quota.amount, 2)}
        />
        <DataRow
          label={"DUE_DATE"}
          value={formatDateReadable(
            new Date(paymentPlanLine.due_date),
            Locale.ES_ES
          )}
        />
        <DataRow
          label={"PAYMENT_STATUS"}
          value={
            <Text tId={`PAYMENT_PLAN_LINE_STATUS_${paymentPlanLine.status}`} />
          }
        />
        {navigateToPaymentPlan && (
          <Box mt={2} display={"flex"} justifyContent={"flex-end"}>
            <Button
              size={"small"}
              variant={"text"}
              color={"primary"}
              onClick={navigateToPaymentPlan}
              endIcon={
                <i className={"material-icons-outlined"}>arrow_forward</i>
              }
              style={{ paddingInline: 4 }}
            >
              <Text tId={"REVIEW_PAYMENT_PLAN"} />
            </Button>
          </Box>
        )}
      </Box>
    </>
  );
};
